import AWSAppSyncClient, {
    createAppSyncLink
} from "aws-appsync";
import aws_config from "../aws-config"
import {
    ApolloLink,
    Observable
} from 'apollo-link';
import {
    onError
} from 'apollo-link-error';
import store from '@/store/index';
//import {    RetryLink} from "apollo-link-retry";
import apolloLogger from 'apollo-link-logger';
import ApolloLinkTimeout from 'apollo-link-timeout';
import auth from '@/data/auth';

class client {
    static get api() {
        const REGION = aws_config().REGION;
        const APPSYNC_URI = aws_config().APPSYNC_URI;
        //const APPSYNC_APIKEY = aws_config.APPSYNC_APIKEY;

        const authLink = onError(({
            graphQLErrors,
            operation,
            forward
        }) => {
            if (graphQLErrors) {
                const errors = graphQLErrors.map(({
                    errorType
                }) => {
                    let err = {};
                    err.errorType = errorType
                    return err;
                });
                if (errors[0].errorType === "UnauthorizedException") {
                    return new Observable(observer => {
                        auth.getRefreshToken().then(res => {
                            res.json().then(res => {
                                    if (res.error && res.error.toLowerCase() == 'invalid_grant') {
                                        store.dispatch("signout");
                                    }
                                    store.dispatch('authenticate', {
                                        accessToken: res.access_token,
                                        idToken: res.id_token,
                                        refreshToken: store.state.auth.refreshToken,
                                        expiresIn: res.expires_in,
                                        noRedirect: true
                                    })

                                    const headers = operation.getContext().headers;
                                    operation.setContext(({
                                        headers: {
                                            // Re-add old headers
                                            ...headers,
                                            // Switch out old access token for new one
                                            "Authorization": `${res.id_token}`
                                        }
                                    }))
                                })
                                .then(() => {
                                    const subscriber = {
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    }

                                    // Retry last failed request
                                    forward(operation).subscribe(subscriber)
                                })
                                .catch(error => {
                                    // No refresh or client token available, we force user to login
                                    observer.error(error)
                                })
                        })
                    })
                }
            }
        });

        const onErrorLink = onError(({
            graphQLErrors,
            networkError
        }) => {
            if (graphQLErrors) {
                const errors = graphQLErrors.map(({
                    message,
                    locations,
                    path,
                    errorType
                }) => {
                    let err = {};
                    err.message = message
                    err.locations = locations
                    err.path = path
                    err.errorType = errorType
                    return err;
                });
                if (errors[0].errorType === "400 Bad Request" && errors[0].message.startsWith('RDSHttp:{"message":"Communications link failure'))
                    store.commit('onStandby', true)
                else
                    store.commit('onError', errors[0])
            }
            if (networkError) {
                console.log('network error')
                store.commit('onError', networkError[0])
            }
        });

        const appSyncLink = createAppSyncLink({
            url: APPSYNC_URI,
            region: REGION,
            auth: {
                type: 'AMAZON_COGNITO_USER_POOLS',
                jwtToken: store.state.auth.idToken
            }
        }, {
            defaultOptions: {
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'none'
                }
            }
        });

        /*const retryLink = new RetryLink({
            delay: {
                initial: 3000,
                max: 10000,
                jitter: true,
            },
            attempts: {
                max: 5,
                retryIf,
            },
        });

        const retryIf = (error) => {
            const doNotRetryCodes = [500, 400, 401];
            return !!error && !doNotRetryCodes.includes(error.statusCode);
        };*/

        const timeoutLink = new ApolloLinkTimeout(30000);

        const link = ApolloLink.from([
            apolloLogger,
            timeoutLink,
            authLink,
            onErrorLink,
            //retryLink,
            appSyncLink
        ]);

        const appclient = new AWSAppSyncClient({
            disableOffline: true
        }, {
            link
        });
        return appclient;
    }
}

export default client;